export default {
    'common.custom': 'Custom',
    'common.default.name': 'Default Name',
    'common.width': 'Width',
    'common.height': 'Height',
    'common.close': 'Close',
    'common.setting': 'Settings',
    'common.switch.open': 'On',
    'common.switch.close': 'Off',
    'common.panel': 'Panel',
    'common.layout': 'Layout',
    'common.basics': 'Basics',
    'common.attr': 'Attributes',
    'common.content': 'Content',
    'common.paper': 'Paper',
    'common.unit': 'Unit',
    'common.font.size.unit': 'Font Unit',
    'common.show': 'Show',
    'common.hidden': 'Hidden',
    'common.xy': 'Coordinates (x/y)',
    'common.position': 'Position',
    'common.place.select': 'Please Select',

    'common.business.widget': 'Business Field',
    'common.common.widget': 'Common Component',
    'common.show.element.design.border': 'Show Element Borders',
    'common.panel.minimap.zoom.in': 'Zoom In',
    'common.panel.minimap.zoom.out': 'Zoom Out',
    'common.panel.minimap.navigation': 'Navigation',
    'common.save.success': 'Save Successful',
    'common.save.fail': 'Save Failed',

    'common.auto': 'Auto',
    'common.fixed': 'Fixed',
    'common.local.upload': 'Local Upload',
    'common.image.url': 'Image URL',

    'common.text': 'Text',
    'common.barcode': 'Barcode',
    'common.qrcode': 'QR Code',
    'common.dotted': 'Dotted',
    'common.dashed': 'Dashed',
    'common.operation.history': 'Operation History',
    'common.mini.map': 'Minimap',
    'common.qr.errorCorrectionLevel.low': 'Low',
    'common.qr.errorCorrectionLevel.medium': 'Medium',
    'common.qr.errorCorrectionLevel.quartile': 'Quartile',
    'common.qr.errorCorrectionLevel.high': 'High'
};
